"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parameters = void 0;
const createApi_1 = require("../../helpers/createApi");
const getTranslations = (caller) => ({ locale }) => caller('api/core/parameters/translations').get({ _locale: locale });
exports.parameters = (0, createApi_1.createAPIFactory)({
    getTranslations,
});
//# sourceMappingURL=api.js.map